const teachingMaterialExr = resolve =>require(['@/components/admin/teachingMaterialExr.vue'], resolve)

export default {
    path: '/appadmin/teachingMaterialExr',
    component: teachingMaterialExr,
    meta: {
        title: '教材习题',
        path:'/appadmin/teachingMaterialExr',
        breadList: [
            {
                title: '首页',
                path: '/homePage'
            },
            {
                title: '教材习题',
                path:'/appadmin/teachingMaterialExr'
            }
        ]
    },
}



// WEBPACK FOOTER //
// ./src/router/admin/teachingMaterialExr.js